const Patio = {
    nombre: 'El Patio - Food & Beer Trucks',
    userInsta: 'elpatiodemerlo',
    idFace: 100063457933917,
    numWpp: [5492664507652],
}

export default Patio
